import React from 'react';
import { SizeVariantsDesktopVersion } from './size-variants-desktop-version';
import { SizeVariantsMobileVersion } from './size-variants-mobile-version';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { FilterType } from 'src/components/price-list/types';
import { createNewSelection } from '../utils';
import { IVariants } from '../types';

const FILTER_TYPE = FilterType.VARIANT_SIZE;

export const SizeVariants: React.FC<IVariants> = props => {
  const { distinctValues, isMobile } = props;
  const {
    getFilter,
    setFilterSelection,
    toggleFilter,
  } = useOfferListFilterContext();
  const filter = getFilter(FILTER_TYPE);
  const selection =
    filter?.active && filter?.selection ? filter?.selection : [];

  const handleSelection = (variant: string | null) => {
    const newSelection = createNewSelection(
      variant,
      selection?.length ? selection : []
    );
    if (filter?.active && newSelection.length === 0) {
      toggleFilter(FILTER_TYPE);
    } else {
      setFilterSelection(FILTER_TYPE, newSelection);
    }
  };

  if (distinctValues.sizes.length <= 1) {
    return null;
  }

  return isMobile ? (
    <SizeVariantsMobileVersion
      handleSelection={handleSelection}
      variants={distinctValues}
    />
  ) : (
    <SizeVariantsDesktopVersion
      handleSelection={handleSelection}
      variants={distinctValues}
    />
  );
};
